import * as React from 'react';

import { WrappedFC } from '../shared/types';

interface Props {
  /** ID番号 */
  num: number;
  /** 表示するコンポーネントの種類 */
  type: 'country' | 'language' | 'region' | 'purchase';
  /** サブタイプ */
  subType?: 'default' | 'full';
  /** 選択状態(true=selected) */
  select?: true | false;
  /** クリック時のCallback */
  onClick: (e: React.MouseEvent) => void;
}

const DEFAULT_COMPONENT: keyof JSX.IntrinsicElements = 'div';
const CLASS_NAME_MAPPING = {
  country: 'country button',
  language: 'language button',
  region: 'region button',
  purchase: 'purchase button'
};

/**
 * ボタンコンポーネント
 */
export const Button: WrappedFC<typeof DEFAULT_COMPONENT, Props> = ({
  num,
  type,
  subType = 'default',
  select = 'default',
  element: Element = DEFAULT_COMPONENT,
  'data-test': dataTest,
  ...props
}) => {
  const _id = type + num;
  const _tmpType = CLASS_NAME_MAPPING[type];
  const _type = subType === 'default' ? _tmpType : `${_tmpType} ${subType}`;
  const _clsName = select ? `${_type} selected` : _type;
  return (
    <Element {...props} id={_id} className={_clsName} data-test={`${dataTest}`}>
      {props.children}
    </Element>
  );
};
Button.displayName = 'Button';
